import React, { useState } from "react";
import { ABOUT_VIDEO, HERO_INTRO } from "../../../assets/images/Images";
import GameCard from "../../../components/cards/GameCard";
import GameData from "../../../components/games/GameData";
import { TestimonialCard } from "../../../components/cards/TestimonialCard";
import TestimonialData from "../../../components/testimonials/TestimonialData";
import PromotoinData from "../../../components/promotions/PromotoinData";
import { PromotionCard } from "../../../components/cards/PromotionCard";
import { ArrowRightOutlined, MobileOutlined } from "@ant-design/icons";
import { HiArrowLongRight } from "react-icons/hi2";
import { BiGlobe } from "react-icons/bi";
import { RiSecurePaymentLine } from "react-icons/ri";
import { FcMultipleDevices } from "react-icons/fc";
import { GrMultiple } from "react-icons/gr";
import DepositCard from "../../../components/cards/DepositCard";
import depositBg from './deposit-bg.png';
import bonusOffer from './bonus-bg.png';

import "./Home.css";

export const Home = () => {
  const [showGames, setShowGames] = useState(false);
  const [selectedAmounts, setSelectedAmounts] = useState({});
  const [visibleCount, setVisibleCount] = useState(10);
const handleSeeMore = () => setVisibleCount(GameData.length);

  const handleAmountChange = (gameId, delta) => {
    setSelectedAmounts((prev) => {
      const current = prev[gameId] || 0;
      const updated = Math.max(current + delta, 0);
      return { ...prev, [gameId]: updated };
    });
  };




  const totalAmount = Object.values(selectedAmounts).reduce((sum, val) => sum + val * 10, 0);

  return (
    <div className="container">
      <div className="message-bar">
        <p><b>Experience quick and easy withdrawals at Cloud9</b> Where your winnings are just a click away</p>
      </div>

      {/* Quick Deposit & Play Section */}
      <section className="section-quick-deposit" data-aos="fade-up">
        <div className="deposit-bg-container" style={{ backgroundImage: `url(${depositBg})` }}>
           <div className="deposit-form">
            <h1 className="section-title glow-title">PLAY & EARN NOW</h1>
            <h1 className="section-title glow-title">QUICK DEPOSIT</h1>
            <div className="form-row">
              
              
            </div>
          
        <button className="btn-start" >Pay With Crypto</button>
            <div className="crypto-options">
              <button className="crypto-btn btc">₿ BTC</button>
              <button className="crypto-btn doge">Ð DOGE</button>
              <button className="crypto-btn ltc">Ł LTC</button>
            </div>
          </div>
          <div className="bonus-image-container">
            <img src={bonusOffer} alt="Bonus Offer" />
          </div>
        </div>
      </section>

{/* Deposit Grid Section */}
<section className="deposit-grid1" data-aos="fade-up">
  {GameData.slice(0, 20).map((game, index) => (
    <DepositCard data={game} key={index} />
  ))}

  
</section>


    <br/> <br/> <br/> <br/> <br/>

      {/* About Section */}
      <section className="section-about" data-aos="fade-up">
        <h1 className="section-title"><b>Step Into the World of Cloud9</b> – Your Ultimate Gaming Destination</h1>
        <p>At Cloud9 Casino, we bring you an unmatched selection of premium games from leading online casino providers, along with the chance to win incredible cash prizes!</p>
        <p>Discover a thrilling variety of games, enticing bonuses, and exclusive promotions that ensure you’ll always have a reason to return for more excitement!</p>
        <p>As a leader in the online casino industry, we deliver state-of-the-art gaming solutions that are both intuitive and reliable. This ensures you enjoy an unparalleled sweepstakes gaming adventure every time!</p>
        <p><b>Join Cloud9</b> today, the ultimate platform that promises an unforgettable gaming journey!</p>
        <button className="btn btn-icon btn-primary mv-3">Sign Up Now <HiArrowLongRight /></button>
      </section>

      {/* Why Choose Us Section */}
      <section className="section-choose" data-aos="fade-up">
        <h1 className="section-title">What Makes Cloud9 Your Best Choice?</h1>
        <ul className="choose-items">
          <li data-aos="fade-up">
            <div className="box"><BiGlobe /></div>
            <div className="content">
              <h4>Immerse Yourself in a True Casino Experience</h4>
              <p>We bring you the newest and most exciting casino games with unbeatable odds...</p>
            </div>
          </li>
          <li data-aos="fade-up">
            <div className="box"><RiSecurePaymentLine /></div>
            <div className="content">
              <h4>Reliable and Secure Payment System</h4>
              <p>Cloud9 Casino offers a robust and secure payment system to safeguard all your transactions...</p>
            </div>
          </li>
          <li data-aos="fade-up">
            <div className="box"><GrMultiple /></div>
            <div className="content">
              <h4>Versatile Multi-Platform Casino Experience</h4>
              <p>Cloud9 Casino brings you access to over 20 premium platforms...</p>
            </div>
          </li>
          <li data-aos="fade-up">
            <div className="box"><MobileOutlined /></div>
            <div className="content">
              <h4>Cloud9 Games are Mobile-Optimized</h4>
              <p>Download the Cloud9 app to enjoy your favorite games on your smartphone...</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
    
  );
};
